// extracted by mini-css-extract-plugin
module.exports = {"page-banner-image":"StandardPageHeader_page-banner-image__e4UXD","header":"StandardPageHeader_header__Jb4tb"};